<script>
import MultiselectDropdown from './MultiselectDropdown.vue';
import ButtonNext from 'dashboard/components-next/button/Button.vue';
import Dropdown from 'dashboard/components-next/wgpt/Dropdown/Dropdown.vue';

export default {
  components: {
    MultiselectDropdown,
    ButtonNext,
    Dropdown,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['remove', 'add'],
  data() {
    return {
      showDropdown: false,
      menuItems: [],
    };
  },
  methods: {
    addItem(item, toggle) {
      this.$emit('add', item);
      toggle();
    },
    removeItem(item) {
      this.$emit('remove');
      this.closeDropdown(item);
    },
    closeDropdown() {
      this.showDropdown = false;
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
  },
};
</script>

<template>
  <div>
    <Dropdown align="end">
      <template #trigger="{ toggle }">
        <ButtonNext
          icon="i-lucide-braces"
          class="absolute ltr:right-0 rtl:left-0 top-0 m-1"
          size="xs"
          color="slate"
          variant="faded"
          @click.prevent="toggle"
        />
      </template>
      <template #default="{ toggle }">
        <div class="!static">
          <MultiselectDropdown
            :options="options"
            :multiselector-title="
              $t(
                'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.EDIT.FORM.MULTI_SELECTOR.TITLE'
              )
            "
            :no-search-result="
              $t(
                'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.EDIT.FORM.MULTI_SELECTOR.SEARCH.NO_RESULTS'
              )
            "
            :input-placeholder="
              $t(
                'WGPT_BOTS.EDIT.TABS.KNOWLEDGE_BASE.TABS.ITEMS.CHUNKS.EDIT.FORM.MULTI_SELECTOR.SEARCH.PLACEHOLDER'
              )
            "
            @add="e => addItem(e, toggle)"
            @remove="removeItem"
            @close="closeDropdown"
          />
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<style lang="scss" scoped>
.button--only-icon ::v-deep {
  .button__content {
    @apply flex justify-center;
  }
}
</style>
